const normalizeTicketText = (value) => {
	const cyrillic = {
		'а':'a','б':'b','в':'v','г':'g','д':'d','ђ':'dj','е':'e','ж':'z','з':'z','и':'i','ј':'j','к':'k','л':'l','љ':'lj','м':'m','н':'n','њ':'nj','о':'o','п':'p','р':'r','с':'s','т':'t','ћ':'c','у':'u','ф':'f','х':'h','ц':'c','ч':'c','џ':'dz','ш':'s'
	};
	return String(value || '')
		.toLocaleLowerCase()
		.replace(/[а-ш]/g, (letter) => cyrillic[letter] || letter)
		.normalize('NFD')
		.replace(/[\u0300-\u036f]/g, '')
		.trim();
};

document.querySelectorAll('[data-ticket-shop]').forEach((shop) => {
	const type = shop.querySelector('[data-ticket-type]');
	const date = shop.querySelector('[data-ticket-date]');
	const search = shop.querySelector('[data-ticket-search]');
	const empty = shop.querySelector('[data-ticket-empty]');
	const events = [...shop.querySelectorAll('[data-ticket-event]')];

	const filter = () => {
		const query = normalizeTicketText(search?.value);
		let visible = 0;
		events.forEach((event) => {
			const matches = (!type?.value || event.dataset.type === type.value)
				&& (!date?.value || event.dataset.date === date.value)
				&& (!query || normalizeTicketText(event.dataset.name).includes(query));
			event.hidden = !matches;
			if (matches) visible += 1;
		});
		if (empty) empty.hidden = visible !== 0;
	};

	type?.addEventListener('change', filter);
	date?.addEventListener('change', filter);
	search?.addEventListener('input', filter);
});
